import React from "react";

import { CSSGridTemplate } from "@components/Layout/CSSGridTemplate";

import { normalizeAreas } from "./CSSGrid.helpers";
import * as Styled from "./CSSGrid.styled";
import type { CSSGridProps } from "./CSSGrid.types";

export const CSSGrid = ({
  areas,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  className: _,
  reverse = false,
  as,
  rowGap,
  ...props
}: CSSGridProps) => (
  <Styled.Root
    forwardedAs={as}
    $rowGap={rowGap}
    $templateRows={props.templateRows}
    areas={normalizeAreas(areas, reverse)}
    {...props}
  />
);

/**
 * To combine columns formed through `repeat`
 *
 * Components should work with `className` prop!
 * @example
 * Grid.areas({ First, Second, Third, Fourth });
 */
CSSGrid.areas = CSSGridTemplate.areas;
